import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppLoadingInterceptor } from './interceptors/app-loading.interceptor';
import { ComponentsModule } from './shared/components/components.module';
import { SharedModule } from './shared/shared.module';
import { AppComponent } from './app.component';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { RouteReuseStrategy, RouterModule } from '@angular/router';
import { LoadingComponent } from './shared/components/loading/loading.component';
import { NewComponentsModule } from './components/components.module';
import { registerLocaleData } from '@angular/common';
import localePy from '@angular/common/locales/es-PY';
import { AgGridModule } from 'ag-grid-angular';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
registerLocaleData(localePy, 'es');
@NgModule({
  declarations: [AppComponent, LoadingComponent],
  imports: [
    IonicModule.forRoot({
      mode: 'md'
    }),
    BrowserModule,
    SharedModule,
    ComponentsModule,
    HttpClientModule,
    AppRoutingModule,
    RouterModule.forRoot([]),
    NewComponentsModule,
    AgGridModule,
    NgxDaterangepickerMd.forRoot() 
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-PY' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AppLoadingInterceptor,
      multi: true,
    },
    {provide: RouteReuseStrategy, useClass: IonicRouteStrategy}
  ],
  bootstrap:[AppComponent]
})
export class AppModule { }
